
const comparisons = [
  {
    aspect: 'Gestão de Clientes',
    without: 'Planilhas desorganizadas, informações perdidas',
    with: 'CRM completo com histórico e alertas automáticos',
    icon: 'ri-team-line',
  },
  {
    aspect: 'Elaboração de Recursos',
    without: 'Horas pesquisando, textos genéricos',
    with: 'IA gera recursos personalizados em segundos',
    icon: 'ri-file-text-line',
  },
  {
    aspect: 'Prospecção de Clientes',
    without: 'Depende de indicações, crescimento lento',
    with: 'Editais com 500+ leads qualificados por semana',
    icon: 'ri-user-search-line',
  },
  {
    aspect: 'Documentação',
    without: 'Contratos manuais, erros de digitação',
    with: 'Documentos gerados automaticamente',
    icon: 'ri-file-copy-line',
  },
  {
    aspect: 'Rastreamento de Multas',
    without: 'Consultas manuais em cada DETRAN',
    with: 'Monitoramento automático em tempo real',
    icon: 'ri-map-pin-line',
  },
  {
    aspect: 'Faturamento',
    without: 'Receita instável, clientes pontuais',
    with: 'Planos recorrentes, receita previsível',
    icon: 'ri-money-dollar-circle-line',
  },
];

export default function ComparisonSection() {
  return (
    <section id="comparacao" className="py-12 md:py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900"></div>
      
      {/* Animated Orbs */}
      <div className="absolute top-1/4 left-0 w-48 md:w-96 h-48 md:h-96 bg-red-500/5 rounded-full blur-3xl animate-blob"></div>
      <div className="absolute bottom-1/4 right-0 w-48 md:w-96 h-48 md:h-96 bg-green-500/5 rounded-full blur-3xl animate-blob" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16 scroll-animate">
          <span className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-orange-500/10 rounded-full mb-4 md:mb-6 border border-orange-500/20 backdrop-blur-sm">
            <i className="ri-contrast-2-line text-orange-400 text-sm md:text-base"></i>
            <span className="text-xs md:text-sm font-semibold text-orange-400">ANTES VS DEPOIS</span>
          </span>
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            A Diferença é Clara
          </h2>
          <p className="text-sm md:text-xl text-gray-400 max-w-3xl mx-auto">
            Veja como a Central da Multa transforma sua operação
          </p>
        </div>

        {/* Mobile: Cards Layout */}
        <div className="md:hidden space-y-4">
          {comparisons.map((item, index) => (
            <div
              key={index}
              className="bg-gray-800/50 backdrop-blur-xl rounded-xl p-4 border border-gray-700/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-white text-lg`}></i>
                </div>
                <span className="font-semibold text-white text-sm">{item.aspect}</span>
              </div>
              <div className="space-y-2">
                <div className="flex items-start gap-2 bg-red-900/10 rounded-lg p-2">
                  <i className="ri-close-line text-red-400 text-sm flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs text-gray-400">{item.without}</span>
                </div>
                <div className="flex items-start gap-2 bg-green-900/10 rounded-lg p-2">
                  <i className="ri-check-line text-green-400 text-sm flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs text-white font-medium">{item.with}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: Table Layout */}
        <div className="hidden md:block bg-gray-800/50 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden border border-gray-700/50 scroll-animate-scale">
          {/* Table Header */}
          <div className="grid grid-cols-3 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900">
            <div className="p-6 font-semibold text-lg text-white">Aspecto</div>
            <div className="p-6 font-semibold text-lg text-center bg-red-900/20 border-l border-r border-gray-700/50">
              <div className="flex items-center justify-center gap-2">
                <div className="w-8 h-8 bg-red-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-close-circle-line text-red-400"></i>
                </div>
                <span className="text-red-400">Sem a Central</span>
              </div>
            </div>
            <div className="p-6 font-semibold text-lg text-center bg-green-900/20">
              <div className="flex items-center justify-center gap-2">
                <div className="w-8 h-8 bg-green-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-green-400"></i>
                </div>
                <span className="text-green-400">Com a Central</span>
              </div>
            </div>
          </div>

          {/* Table Rows */}
          {comparisons.map((item, index) => (
            <div
              key={index}
              className={`grid grid-cols-3 transition-all duration-300 hover:bg-gray-700/30 group ${
                index % 2 === 0 ? 'bg-gray-800/30' : 'bg-gray-800/10'
              }`}
            >
              <div className="p-6 flex items-center gap-4 border-r border-gray-700/30">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-orange-500/30">
                  <i className={`${item.icon} text-white text-xl`}></i>
                </div>
                <span className="font-semibold text-white group-hover:text-yellow-400 transition-colors duration-300">{item.aspect}</span>
              </div>
              <div className="p-6 flex items-center border-r border-gray-700/30 bg-red-900/5">
                <div className="flex items-start gap-3">
                  <i className="ri-close-line text-red-400 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-400">{item.without}</span>
                </div>
              </div>
              <div className="p-6 flex items-center bg-green-900/5">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-green-400 text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-white font-medium">{item.with}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 md:mt-12 text-center scroll-animate">
          <div className="inline-flex flex-col md:flex-row items-center gap-4 md:gap-6 bg-gradient-to-r from-orange-500 to-amber-500 rounded-xl md:rounded-2xl p-6 md:p-8 relative overflow-hidden group">
            {/* Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
            
            <div className="text-center md:text-left relative z-10">
              <p className="text-white/90 text-sm md:text-lg">Pronto para transformar seu negócio?</p>
              <p className="text-white text-lg md:text-2xl font-bold">Comece agora mesmo</p>
            </div>
            <button
              onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-6 md:px-8 py-3 md:py-4 bg-white text-orange-600 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap relative z-10 hover:scale-105 hover:shadow-lg text-sm md:text-base"
            >
              Quero Testar Grátis
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
